import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/**
 * What each assessor detail means to an owner: assessed values drive the tax bill,
 * measurements are reference. The current roll is labelled by the collector's own
 * table; history rows carry the DataSF column names written as sentences
 * ("year_property_built" becomes "Year property built").
 */
const TAX = 'changes the basis for the property tax bill';
export const fieldMeanings = declareFieldMeanings({
  sources: ['assessor'],
  declarations: [
    identity(
      'parcelNumber',
      'Parcel number',
      'Block',
      'Lot',
      'Assessor address',
      'Property location',
      'year',
      'parcel_number',
      'block',
      'lot',
    ),
    administrative(
      'closed_roll_year',
      'Closed assessment year',
      'Volume number',
      'Lot code',
      'tra',
      'Tax rate area',
      'Tax rate area code',
      'analysis_neighborhood',
      'Analysis neighborhood',
      'neighborhoods_analysis_boundaries',
      'Neighborhoods analysis boundaries',
      'Neighborhood',
      'Assessor neighborhood',
      'Assessor neighborhood code',
      'Assessor neighborhood district',
      'supervisor_district',
      'Supervisor district',
      'Supervisor district 2012',
      'supervisorial_district',
      'Supervisorial district',
      'zipcode',
      'ZIP code',
      'the_geom',
      'Location',
      'historySourceUrl',
      'data_as_of',
      'Data as of',
      'data_loaded_at',
      'Data updated',
      'objectid',
      'row_id',
      'Record ID',
    ),
    means('amount', 'the assessed land value', ['Assessed land value', 'landval'], {
      matters: TAX,
    }),
    means('amount', 'the assessed improvement value', ['Assessed improvement value', 'strucval'], {
      matters: TAX,
    }),
    means('amount', 'the assessed fixtures value', ['Assessed fixtures value', 'fixtval'], {
      matters: TAX,
    }),
    means(
      'amount',
      'the assessed personal property value',
      ['Assessed personal property value', 'othrval'],
      {
        matters: TAX,
      },
    ),
    means('amount', 'the recorded sale price', [
      'Prior sale price',
      'priorprice',
      'Current sale price',
      'currprice',
    ]),
    means('date', 'the recorded sale date', [
      'Prior sale date',
      'priorsaledate',
      'Current sale date',
      'currsaledate',
      'Current sales date',
    ]),
    means(
      'detail',
      'the tax exemption code',
      ['Exemption code', 'exemptcode', 'Exemption code definition'],
      { matters: 'changes an exemption that affects the tax bill' },
    ),
    means('amount', 'an exemption value', ['Homeowner exemption value', 'Misc exemption value'], {
      matters: 'changes an exemption that reduces the tax bill',
    }),
    means('status', 'the roll status code', ['Status code']),
    means('detail', 'the ownership share assessed', ['Percent of ownership'], {
      matters: 'changes the share of the property the assessment covers',
    }),
    means(
      'detail',
      "the assessor's use classification",
      [
        'Use code',
        'usecode',
        'Use type',
        'UseClass_DESCRIPTION',
        'Use definition',
        'Property class code',
        'Property class code definition',
      ],
      {
        matters: 'can change how the property is taxed and regulated',
      },
    ),
    means('detail', 'the zoning code', ['Zoning code'], {
      matters: 'can change what the property may be used for',
    }),
    means('detail', 'the recorded construction type', [
      'Construction code',
      'construction',
      'Construction type',
      'ConstrType_ConstrDesc',
      'constrdesc',
    ]),
    means('detail', 'a recorded building or parcel measurement', [
      'Parcel shape',
      'lotshape',
      'Parcel frontage',
      'lotfrontage',
      'Parcel depth',
      'lotdepth',
      'Parcel area',
      'lotarea',
      'Basement area',
      'basement',
      'Building area',
      'bldgsqft',
      'Property area',
      'Year built',
      'yrbuilt',
      'Year property built',
      'Stories',
      'stories',
      'Number of stories',
      'Units',
      'units',
      'Number of units',
      'Rooms',
      'rooms',
      'Number of rooms',
      'Bedrooms',
      'bedrooms',
      'Number of bedrooms',
      'Bathrooms',
      'bathrooms',
      'Number of bathrooms',
      'Lot depth',
      'Lot frontage',
      'Lot area',
    ]),
  ],
});
